import React, { Fragment, ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import Card from '../card/card.component';
import TextBold from '../text-bold/text-bold.component';
import SwipeableSlider from '../swipeable-slider/swipeable-slider.component';
import useStylesStatisticsBlock from './statistics-block.styles';

const StatisticsBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const STATISTIC_ITEM_WIDTH: number = 270;

  const {
    statisticItemList,
  } = props;

  const { classes } = useStylesStatisticsBlock();

  return (
    <Fragment>
      {
        statisticItemList && !!statisticItemList.length && (
          <Card className={classes.statisticsBlock}>
            <SwipeableSlider isStretched withControlsVisible withLightControls slideItemWidth={STATISTIC_ITEM_WIDTH}>
              {
                statisticItemList.map((statisticItem: StatisticItem): ReactElement => (
                  <FlexContainer isFlexStart isColumn key={statisticItem.id} className={classes.statisticsItemBlock}>
                    <FlexContainer className={classes.statisticsItemBlockName}>
                      {statisticItem.title}
                    </FlexContainer>
                    <FlexContainer className={classes.statisticsItemBlockValue}>
                      <TextBold isHighlighted>
                        {statisticItem.value}
                      </TextBold>
                    </FlexContainer>
                  </FlexContainer>
                ))
              }
            </SwipeableSlider>
          </Card>
        )
      }
    </Fragment>
  );
});

export default StatisticsBlock;
